import {useState, useEffect, useMemo} from 'react'
import {useSelector} from 'react-redux'
import {toUpper} from 'lodash'
import {findMatchingArrayName} from '../../../../../../Utils/_helpers'
import {GLOBAL_SETTINGS_TYPE} from '../../../../../../Utils/Constant/ConstantForWebsite'
import {getBusinessName} from '../../../../accounts/BusinessName/BusinessNameSlice/BusinessSlice'
import {getCustomNunberList} from '../../../../accounts/CustomNumber/CustomNumberSlice/CustomNumberSlice'
import {getDedicatedNumber} from '../../../../accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import {
  getIsDefaultRegion,
  getDefaultRegion,
  getAllUserDetails,
} from '../../../../accounts/Overview/OverviewSlice/UserDetailsSlice'

export const SENDER_TYPE_DEFAULT = '#SharedNum#'
export const SENDER_DEFAULT = '#SharedNum#'

export function useSenderId(
  sender: string = SENDER_DEFAULT,
  senderType: string = SENDER_TYPE_DEFAULT
) {
  const quickDraftData = useSelector((state: any) => state?.quickMsg?.QuickMsgDraftData)
  const OptOutDefault = useSelector((state: any) => state?.userDetails?.userDetails?.data?.user)
  const optoutList = useSelector((state: any) => {
    const userGlobalSettings = state?.userDetails?.userDetails?.data?.user?.globalSetting
    let list = state?.optoutList?.optoutList?.data?.items || []
    if (quickDraftData?.camp_type === 'sms') {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        GLOBAL_SETTINGS_TYPE.QUICK_SMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }
    if (quickDraftData?.camp_type === 'mms') {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        GLOBAL_SETTINGS_TYPE.QUICK_MMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }
    return list
  })

  const isAdmin = localStorage.getItem('isAdmin')
  const alphaID = ['businessName', 'customNumber']
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const userRegion = useSelector(getDefaultRegion)
  const virtualNumber = useSelector(getDedicatedNumber)
  const bussinessName = useSelector(getBusinessName)
  const CustomNumberList = useSelector(getCustomNunberList)
  const userDetail: any = useSelector(getAllUserDetails)

  const [selectedSender, setSelectedSender] = useState<any>(sender || '')
  const [selectedSenderType, setSelectedSenderType] = useState<any>(senderType || '')
  const [isShowCredit, setIsShowCredit] = useState(true)
  const [visible, setVisible] = useState<any>(false)
  const [name, setName] = useState(false)
  const [customNumber, setCustomNumber] = useState(false)

  useEffect(() => {
    if (userDetail && userDetail.subClientAccountId && userDetail.subClientAccountId !== '') {
      if (userDetail._id !== userDetail.ownerId) {
        setIsShowCredit(false)
      }
    }
  }, [userDetail])

  const dedicatedOptionMMS = useMemo(
    () =>
      virtualNumber && Array.isArray(virtualNumber)
        ? virtualNumber
            .filter((key: any) => toUpper(key?.type) === 'MMS' && key?.status === 'active')
            .map((key: any) => ({
              value: key?.audNumber,
              label: key?.audNumber,
              disabled: key?.status === 'inactive',
            }))
        : [],
    [virtualNumber]
  )

  const dedicatedOptionSMS = useMemo(
    () =>
      virtualNumber && Array.isArray(virtualNumber)
        ? virtualNumber
            .filter((key: any) => toUpper(key?.type) === 'SMS' && key?.status === 'active')
            .map((key: any) => ({
              value: key?.audNumber,
              label: key?.audNumber,
              disabled: key?.status === 'inactive',
            }))
        : [],
    [virtualNumber]
  )

  const businessNameOption = useMemo(
    () =>
      bussinessName && Array.isArray(bussinessName)
        ? bussinessName
            .filter((key: any) => key?.status === 'ACTIVE')
            .map((key: any) => ({
              value: key?.businessname,
              label: key?.businessname,
            }))
        : [],
    [bussinessName]
  )

  const customNumberOption = useMemo(
    () =>
      CustomNumberList && Array.isArray(CustomNumberList)
        ? CustomNumberList.filter((key: any) => key?.status === 'active').map((key: any) => ({
            value: key?.number,
            label: key?.number,
          }))
        : [],
    [CustomNumberList]
  )

  const senderTypeData = useMemo(
    () => [
      {name: '#SharedNum#', array: [{value: '#SharedNum#', label: '#SharedNum#'}]},
      {name: 'dedicatedNumber', array: [...dedicatedOptionSMS, ...dedicatedOptionMMS]},
      {name: 'businessName', array: businessNameOption},
      {name: 'customNumber', array: customNumberOption},
    ],
    [dedicatedOptionSMS, dedicatedOptionMMS, businessNameOption, customNumberOption]
  )

  const handleSenderChange = (e: any) => {
    setSelectedSender(e?.value)
    setSelectedSenderType(findMatchingArrayName(e?.value, senderTypeData))
  }

  useEffect(() => {
    setSelectedSender(sender || '')
    setSelectedSenderType(senderType || '')
  }, [sender, senderType])

  return {
    selectedSender,
    setSelectedSender,
    selectedSenderType,
    setSelectedSenderType,
    isDefaultRegion,
    userRegion,
    isShowCredit,
    dedicatedOptionMMS,
    dedicatedOptionSMS,
    businessNameOption,
    customNumberOption,
    senderTypeData,
    handleSenderChange,
    quickDraftData,
    OptOutDefault,
    optoutList,
    visible,
    setVisible,
    name,
    setName,
    customNumber,
    setCustomNumber,
    isAdmin,
    alphaID,
  }
}
